import { render, staticRenderFns } from "./Razglednica.vue?vue&type=template&id=a40d8b94&scoped=true&"
import script from "./Razglednica.vue?vue&type=script&lang=js&"
export * from "./Razglednica.vue?vue&type=script&lang=js&"
import style0 from "./Razglednica.vue?vue&type=style&index=0&id=a40d8b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40d8b94",
  null
  
)

export default component.exports